export default "__VITE_ASSET__oV_KJc$k__"